<template>
  <v-app-bar
    app
    flat
    dark
    color="primary"
    fixed
    height="58"
    ref="toolbar"
    id="app-toolbar"
  >
    <!-- Replaced v-toolbar-side-icon with v-app-bar-nav-icon -->
    <v-app-bar-nav-icon
      v-if="!stateless"
      @click.stop="drawerToggle"
    ></v-app-bar-nav-icon>

    <v-toolbar-title>{{ currentOrganization.name }}</v-toolbar-title>

    <v-spacer />

    <!-- <v-btn icon @click.stop="helpToggle" v-if="!stateless">
      <v-icon>mdi-help-circle</v-icon>
    </v-btn> -->

    <!-- <LaunchTerminal class="px-1" /> -->
    <TasksButton />
    <ToolbarMenu />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ToolbarMenu from "./Menu.vue";
import TasksButton from "../../Tasks/components/Button";
// import LaunchTerminal from "./LaunchTerminal";

export default {
  data() {
    return {
      stateless: false,
    };
  },
  methods: {
    ...mapActions("layout", ["drawerToggle", "helpToggle"]),
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
  },
  components: {
    ToolbarMenu,
    TasksButton,
    // LaunchTerminal,
  },
};
</script>

<style scoped></style>